function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 22.5a10.5 10.5 0 100-21 10.5 10.5 0 000 21zM24 12a12 12 0 11-24 0 12 12 0 0124 0z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.796 4.615a.7.7 0 01.51.223c.134.143.21.336.21.538v7.926l4.675 2.824c.16.103.277.268.324.46a.799.799 0 01-.071.569.727.727 0 01-.428.354.685.685 0 01-.54-.062l-5.036-3.043a.74.74 0 01-.266-.279.793.793 0 01-.097-.381V5.376c0-.202.076-.395.21-.538a.7.7 0 01.51-.223z",
  fill: "#fff"
});

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgClock;